/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemRateEntryInputDto } from './OemRateEntryInputDto';
import {
    OemRateEntryInputDtoFromJSON,
    OemRateEntryInputDtoFromJSONTyped,
    OemRateEntryInputDtoToJSON,
    OemRateEntryInputDtoToJSONTyped,
} from './OemRateEntryInputDto';

/**
 * 
 * @export
 * @interface CreateOemPartnerRequestDto
 */
export interface CreateOemPartnerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerRequestDto
     */
    partnerOrgId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerRequestDto
     */
    partnerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateOemPartnerRequestDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOemPartnerRequestDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerRequestDto
     */
    status?: CreateOemPartnerRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<OemRateEntryInputDto>}
     * @memberof CreateOemPartnerRequestDto
     */
    rateEntries: Array<OemRateEntryInputDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const CreateOemPartnerRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type CreateOemPartnerRequestDtoStatusEnum = typeof CreateOemPartnerRequestDtoStatusEnum[keyof typeof CreateOemPartnerRequestDtoStatusEnum];


/**
 * Check if a given object implements the CreateOemPartnerRequestDto interface.
 */
export function instanceOfCreateOemPartnerRequestDto(value: object): value is CreateOemPartnerRequestDto {
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('rateEntries' in value) || value['rateEntries'] === undefined) return false;
    return true;
}

export function CreateOemPartnerRequestDtoFromJSON(json: any): CreateOemPartnerRequestDto {
    return CreateOemPartnerRequestDtoFromJSONTyped(json, false);
}

export function CreateOemPartnerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOemPartnerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerOrgId': json['partnerOrgId'] == null ? undefined : json['partnerOrgId'],
        'partnerName': json['partnerName'] == null ? undefined : json['partnerName'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'] == null ? undefined : json['status'],
        'rateEntries': ((json['rateEntries'] as Array<any>).map(OemRateEntryInputDtoFromJSON)),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateOemPartnerRequestDtoToJSON(json: any): CreateOemPartnerRequestDto {
    return CreateOemPartnerRequestDtoToJSONTyped(json, false);
}

export function CreateOemPartnerRequestDtoToJSONTyped(value?: CreateOemPartnerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'validFrom': value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
        'rateEntries': ((value['rateEntries'] as Array<any>).map(OemRateEntryInputDtoToJSON)),
        'notes': value['notes'],
    };
}

